module.exports = __webpack_public_path__ + "static/media/gogochart_greenlogo.bcda2c8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/gogochart_greenlogo.png
// module id = 1416
// module chunks = 0